import _ from 'lodash';

import { LOAD, INITIALIZE, LOGOUT, UPDATE_CURRENT_USER } from './action-types';


const defaultState = { token: null, profile: {}, currentUser: {} };

function auth(state = defaultState, action) {
  switch (action.type) {
    case INITIALIZE:
      return _.assign({}, state, _.omit(action, 'type'));
    case LOAD:
      return _.assign({}, state, _.omit(action, 'type'));
    case LOGOUT:
      return _.assign({}, state, defaultState);
    case UPDATE_CURRENT_USER:
      return _.assign({}, state, { currentUser: action.currentUser });
    default:
      return state;
  }
}

export default auth;



// WEBPACK FOOTER //
// ./app/modules/auth/reducers.js